export const AssertionException = (message) => new Error(`Assertion exception: ${message}`);
